module.exports = __webpack_public_path__ + "static/media/11_7.48a8d46e.jpg";